<template>
  <splitpanes class="default-theme splitPanesMain"
              :push-other-panes="false">
    <pane size='50'
          min-size="20"
          max-size="80">
      <div class="splitPanesMain_leftMenu">
        <a-card title="我的菜单"
                :bordered="false">
          <a-tree v-if="menus.length > 0"
                  :tree-data="menus"
                  :default-expanded-keys="['0']"
                  :show-line="true"
                  :field-names="{ key: 'id', title: 'name' }">
            <template #title="{ name, key }">
              <span v-if="key === '0-0-0-0'"
                    style="color: #1890ff">{{ name }}</span>
              <template v-else>{{ name }}</template>
            </template>
          </a-tree>
          <a-empty v-else></a-empty>
        </a-card>
      </div>
    </pane>
    <pane size='50'>
      <div class="splitPanesMain_rightMenu">
        <a-card title="我的操作"
                :bordered="false">
          <a-tree v-if="operations.length > 0"
                  :tree-data="operations"
                  :default-expanded-keys="['0']"
                  :show-line="true"
                  :field-names="{ key: 'id', title: 'name' }">
            <template #title="{ name, key }">
              <span v-if="key === '0-0-0-0'"
                    style="color: #1890ff">{{ name }}</span>
              <template v-else>{{ name }}</template>
            </template>
          </a-tree>
        </a-card>
      </div>
    </pane>
  </splitpanes>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
import { merge } from 'lodash'
import { Pane, Splitpanes } from 'splitpanes'
import { onMounted, reactive } from 'vue'
import { useRbacStore } from '../DefaultRbacPagePlugin'
import { convertArrayToTree } from '@/utils'

const rbac = useRbacStore()
const menus: any[] = reactive([])
const operations: any[] = reactive([])

onMounted(() => {
  // 获取管理菜单
  rbac.fetchMenus().then(() => {
    merge(menus, rbac.menus.tree)
  })
  // 获取操作菜单
  rbac.fetchOperations().then(() => {
    merge(operations, convertArrayToTree(rbac.operations).tree)
  })
})

</script>

<style lang="less" scoped>
.splitPanesMain {
  height: 93vh;

  &_leftMenu {
    height: 99%;
    margin: 3px;
    background-color: white;
    box-shadow: 3px 0 2px #e8e3e3;
    overflow: auto
  }

  &_rightMenu {
    height: 99%;
    margin: 3px;
    background-color: white;
    box-shadow: 3px 0 2px #e8e3e3;
    overflow: auto
  }
}

:deep(.splitpanes__splitter) {
  background-color: #fbf3f314 !important;
}
</style>
